<template>
    <v-container>
        <v-row class="mt-6 ml-6">
            <v-text-field v-model="search_text" single-line="" class="input_600 ml-3" outlined></v-text-field>
        </v-row>

        <v-row class="mt-6 ml-6">
            <v-col cols="12" sm="12">
                <v-data-table :search="search_text" :headers="headers" :items="table_data" hide-default-footer class="elevation-1">
                    <template v-slot:item.index="{item}">
                        {{table_data.findIndex(e=>e.id==item.id)+1}}
                    </template>
                    <template v-slot:item.name="{item}">
                        <p style="min-width: 120px;">{{item.name}}</p>
                    </template>
                    <template v-slot:item.set="{item}">
                        <!-- {{item}} -->
                        <v-btn v-if="mode==0" :to="'/question_statistics?as='+item.account_survey_id" class="ma-1" small color="success">查看</v-btn>
                        <v-checkbox v-if="mode==1" v-model="item.checked" @change="change_select(item)" label="選擇"></v-checkbox>
                    </template>
                    <!-- <template v-slot:item.created_at="{item}">
                        {{UTC2ToLocal(item.created_at)}}
                    </template> -->
                </v-data-table>
            </v-col>
        </v-row>

        <v-row class="mt-6 ml-6">
            <v-spacer></v-spacer>
            <v-btn v-if="mode==1" to="/question_analysis" class="ml-3" color="success">進入分析</v-btn>
        </v-row>

    </v-container>
</template>

<script>
var host_url = process.env.VUE_APP_HOST_URL
import bus from '../nav/bus'

export default {
    data(){
        return {
            // 0: 從統計圖表點選子問卷進來 
            // 1:從交叉分析點選擇近來
            mode: -1,
            search_text: "",
            page: 0,
            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '問卷名稱', align: 'center', value: 'title',  sortable: false},
                {text: '建立時間', align: 'center', value: 'created_at', width: 200, sortable: false},
                {text: '所屬廠商', align: 'center', value: 'vendor', width: 200, sortable: false},
                {text: '所屬醫師', align: 'center', value: 'doctor', width: 200, sortable: false},
                {text: '發出數量', align: 'center', value: 'send_num', width: 80, sortable: false},
                {text: '完成數量', align: 'center', value: 'success_num', width: 80, sortable: false},
                {text: '操作', align: 'center', value: 'set', width: 100, sortable: false},
            ],
            table_data: [],
            survey_id: -1,
        }
    },
    created(){
        this.init()
        // 0：從統計圖表點選子問卷進來
        // 1:從交叉分析點選擇進來
        let check = 'm' in this.$route.query && 's' in this.$route.query
        if(!check){
            bus.$emit('alert', {msg: '操作異常', title: "提示",　check: "我知道了"})
            this.$router.push('/statistics')
        }
        this.mode = this.$route.query.m
        this.survey_id = this.$route.query.s
        this.get_son_survey()
        
    },
    methods: {
        UTC2ToLocal(date) {
            date = new Date(date)
            var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();
            newDate.setHours(hours - offset);

            if(newDate.getMinutes()<10 && newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getMinutes()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":"+newDate.getMinutes()
            else
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":"+newDate.getMinutes()

            return newDate
        },
        change_select(item){
            console.log(item)
            let son_survey_selected = JSON.parse(localStorage.getItem('SON_SURVEY_SELECTED'))
            if(item.checked){
                son_survey_selected.push(item.account_survey_id)
            }   
            else{
                son_survey_selected.splice(son_survey_selected.findIndex(e=>e.account_survey_id==item.account_survey_id), 1)
            }
            localStorage.setItem('SON_SURVEY_SELECTED', JSON.stringify(son_survey_selected))
            console.log(son_survey_selected)
        },
        init(){
            localStorage.setItem('SON_SURVEY_SELECTED',JSON.stringify([]))
        },
        get_son_survey(){
            let post_data = {survey_id: this.survey_id}
            axios.post(host_url+'get_son_survey_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.table_data
                    console.log(this.table_data)
                }
                else{
                    bus.$emit('alert', {msg: '抓取問卷失敗！', title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_600{
    max-width: 600px;
}

</style>